import { FormControlLabel, Radio } from "@material-ui/core";
import muiRadioModuleCss from "../../../assets/css/mui.radio.module.css";
import muiInputLabelModuleCss from "../../../assets/css/mui.radio.input-label.module.css";

type Param = {
    value: unknown,
    label?: string
}

const RadioField: React.FC<Param> = (props) => {
    const { value, label } = props;

    const radioCmp = <Radio classes={muiRadioModuleCss} color='default' />;
    return <FormControlLabel classes={muiInputLabelModuleCss} value={value} control={radioCmp} label={label} />

}

export default RadioField;